export default function Trust({ data }) {
  const items = data?.items || [];
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="bg-sage/40 border-y border-beige/60 py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <ul className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6 divide-y md:divide-y-0 md:divide-x divide-beige">
          {items.map((label, idx) => (
            <li
              key={idx}
              data-testid={`trust-item-${idx}`}
              className="reveal text-center md:px-4 first:pt-0 pt-6 md:pt-0"
            >
              <div className="font-display text-2xl sm:text-3xl md:text-[2rem] leading-tight text-teal-600">
                {label}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
